if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.timer = null;
        this.onMotionChange = this.onMotionChange.bind(this);
        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
        this.status = this.querySelector('[data-announcement-status]');
        if (this.slides.length < 2 || !this.hasAttribute('data-autoplay')) return;

        this.interval = Number(this.dataset.interval) || 5000;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionQuery.addEventListener('change', this.onMotionChange);

        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.resume);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.resume);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
        this.removeEventListener('mouseenter', this.pause);
        this.removeEventListener('mouseleave', this.resume);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.resume);
      }

      start() {
        if (this.motionQuery.matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.stop();
      }

      resume() {
        this.start();
      }

      onMotionChange() {
        if (this.motionQuery.matches) {
          this.stop();
          this.show(0);
        } else {
          this.start();
        }
      }

      show(next) {
        const target = ((next % this.slides.length) + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== target;
        });
        this.index = target;

        if (this.status) {
          const message = this.slides[target].textContent.trim().replace(/\s+/g, ' ');
          this.status.textContent = message;
        }
      }
    },
  );
}
